import {Button, Input, message, Modal} from 'antd'
import {
    article_deleteEnhancedArticle_Api,
    bookmarks_mark_Api,
    bookmarks_unMark_Api,
    pin_mark_Api,
    pin_unMark_Api,
    poll_delete_Api,
    post_deletePost_Api,
} from 'apis'
import {articleModel} from 'apis/model'
import {baseItemSchema} from 'apis/schema'
import {createTransform} from 'apis/utils/createTransform'
import ApiInfoForm from 'components/form/ApiInfoForm'
import {SelectEntityItem} from 'components/SelectEntityItem'
import UseState from 'components/UseState'
import copyToClipboard from 'copy-to-clipboard'
import {API_ROOT_URL, ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import {createAsyncAction} from 'modules/asyncCache'
import Async from 'modules/asyncCache/components/Async'
import {useDispatchAsyncOnlyActionWithNotify} from 'modules/asyncCache/useDispatchAsyncActionWithNotify'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import PermissionProvider from 'modules/permissions/PermissionProvider'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {IoFolderOpenOutline} from 'react-icons/io5'
import Loadable from 'react-loadable'
import {collectionsSchema} from 'views/Bookmark/collectionsSchema'
import {decryptContent} from 'views/Chart/mapParams/dataHelpers'
import {useExtraVote, useVote} from 'views/Server/ServerContainer'
import ServerContext from 'views/Server/ServerContext'
import {useRequiredLogin} from 'views/Server/useRequiredLogin'
import {ask_deleteAsk_Api} from '../../apis/ask'
import {getId, getType} from '../../apis/model/base'
import {EnhancedEditAsk} from '../../views/Asks/AskEditorForm/AskEditorForm'
import {EnhancedEditPoll} from '../../views/CreatePoll/EditPoll'
import FeedSetChannelForm from '../../views/Feed/FeedSetChannelForm'
import {LoginContext} from '../LoginContext'
import FeedContext from './FeedContext'
import {showConfirm, transformAlias} from './TimeLineFeed'
import {VoteTypes} from './Vote'
import FeedQuoteForm from "../../views/Feed/FeedQuoteForm";
import {NullAsDefault} from "../../views/Shared";
import {useFeedback} from "../../views/AppLocals/Feedback/functions/useFeedback";
import LoadingBlock from "../../views/LoadingBlock";
import getLinkToDetail from "../../helpers/getLinkToDetail";
import {PostFormProvider} from "./PostForm/PostFormContext";

const FeedSetting = Loadable({
    loader: () => import('views/Feed/FeedSetting'),
    loading: NullAsDefault,
})

export const FeedProvider = ({
                                 detail,
                                 children,
                                 item: raw_item,
                                 defaultActions = [],
                             }) => {
    const t = useTranslate()
    const [hide, setHide] = useState(false)
    const {item: container} = useContext(ServerContext)
    const [modal, setmodal] = useState()
    const login = useContext(LoginContext)
    const history = useHistory()

    const decrypted_data = useCallback(
        (value, item, transform) => {
            if (['document'].includes(getType(raw_item))) {
                return value
            }
            return decryptContent(value, item, transform) ?? []
        },
        [raw_item]
    )

    const item = useMemo(() => {
        const base = {...(raw_item ?? {})};
        if (getType(raw_item) === 'post') {
            return {
                ...base,
                embed_data: {
                    ...(raw_item?.embed_data ?? {}),
                    content_data: decrypted_data(raw_item?.embed_data?.content_data, raw_item?.embed_data),
                },
            };
        }
        return {
            ...base,
            content_data: decrypted_data(raw_item?.content_data, raw_item),
        };
    }, [raw_item, decrypted_data]);

    const [
        creatorId,
        created,
        creatorType,
        creatorName,
        title,
        description,
        cover,
        id,
        type,
        photos,
        embed_data,
        embed
    ] = transformAlias(item, [
        'creatorId',
        'created',
        'creatorType',
        'creatorName',
        'title',
        'description',
        'cover',
        'id',
        'type',
        'photos',
        'embed_data',
        'embed'
    ])
    const content_data = useMemo(() => (
        item._type === 'post' ? _.get(item, 'embed_data.content_data', []) : _.get(item, 'content_data', [])
    ), [item]);

    const dispatch = useDispatchAsyncOnlyActionWithNotify()
    const vote_status = _.get(item, 'vote_status')
    const bookmark_status = _.get(item, 'bookmark_status')
    const total_votes = _.get(item, 'total_votes')
    const total_downvotes = _.get(item, 'total_downvotes')
    const handleVote = useVote({
        vote_status,
        total_votes,
        owner_type: type,
        owner_id: id,
    })
    const handleExtraVote = useExtraVote({
        vote_status,
        owner_type: type,
        owner_id: id,
    })
    const translate = useTranslate()
    const handleRequiredLogin = useRequiredLogin()
    const url = getLinkToDetail(item)
    const shareUrl = `${ROOT_URL}${url}`

    const {reportModal, handleReport} = useFeedback({
        notifyListeners: {}
    })

    function handleClick(key) {
        switch (key) {
            case 'to':
                history.push({
                    pathname: getLinkToDetail(item),
                })
                break
            case 'edit':
                if (type === 'article') {
                    const editingURL = articleModel.getEditingURL(item)
                    history.push({
                        pathname: editingURL,
                    })
                }
                if (type === 'post') {
                    setmodal(
                        <FeedSetting
                            id={id}
                            type={type}
                            onCancel={() => setmodal(null)}
                        />
                    )
                }
                if (type === 'poll_question') {
                    setmodal(
                        <PostFormProvider container={{id: getId(item?.container), type: getType(item?.container)}}>
                            <EnhancedEditPoll
                                pollItem={item}
                                onCancel={() => setmodal(null)}
                            />
                        </PostFormProvider>
                    )
                }
                if (type === 'ask') {
                    setmodal(
                        <PostFormProvider container={{id: getId(item?.container), type: getType(item?.container)}}>
                            <EnhancedEditAsk
                                askItem={item}
                                onCancel={() => setmodal(null)}
                            />
                        </PostFormProvider>
                    )
                }
                break
            case 'set_channel':
                setmodal(
                    <FeedSetChannelForm
                        id={id}
                        onCancel={() => setmodal(null)}
                    />
                )
                break
            case 'share_on_channel':
            case 'quote':
                handleRequiredLogin(() => {
                    setmodal(
                        <PostFormProvider defaultChannel={item?.container}>
                            <FeedQuoteForm
                                id={getId(item)}
                                type={getType(item)}
                                onCancel={() => setmodal(null)}
                            />
                        </PostFormProvider>
                    )
                })
                break
            case 'delete':
                switch (type) {
                    case 'ask':
                        showConfirm({
                            title: translate('Are you sure delete this ask'),
                            className: 'custom-modal',
                            okText: t('sure'),
                            cancelText: t('ignore'),
                            okButtonProps: {
                                type: 'primary',
                                danger: true,
                                className: 'rounded-lg no-shadow no-text-shadow no-border',
                            },
                            cancelButtonProps: {
                                className: 'rounded-lg no-shadow no-text-shadow no-border text-color-200',
                            },
                            onOk: () => {
                                dispatch(
                                    createAsyncAction({
                                        apiInfo: ask_deleteAsk_Api,
                                        query: {
                                            ':ask_id': item.idname,
                                        },
                                    })
                                )
                            },
                        })
                        break
                    case 'poll_question':
                        showConfirm({
                            title: translate('Are you sure delete this poll'),
                            className: 'custom-modal',
                            okText: t('sure'),
                            cancelText: t('ignore'),
                            okButtonProps: {
                                type: 'primary',
                                danger: true,
                                className: 'rounded-lg no-shadow no-text-shadow no-border',
                            },
                            cancelButtonProps: {
                                className: 'rounded-lg no-shadow no-text-shadow no-border text-color-200',
                            },
                            onOk: () => {
                                dispatch(
                                    createAsyncAction({
                                        apiInfo: poll_delete_Api,
                                        query: {
                                            ':poll_question_id': item.idname,
                                        },
                                    })
                                )
                            },
                        })
                        break
                    case 'article':
                        showConfirm({
                            title: translate('Are you sure delete this articles'),
                            className: 'custom-modal',
                            okText: t('sure'),
                            cancelText: t('ignore'),
                            okButtonProps: {
                                type: 'primary',
                                danger: true,
                                className: 'rounded-lg no-shadow no-text-shadow no-border',
                            },
                            cancelButtonProps: {
                                className: 'rounded-lg no-shadow no-text-shadow no-border text-color-200',
                            },
                            onOk: () => {
                                dispatch(
                                    createAsyncAction({
                                        apiInfo: article_deleteEnhancedArticle_Api,
                                        query: {
                                            ':article_id': item.id,
                                        },
                                    })
                                )
                            },
                        })

                        break
                    default:
                        showConfirm({
                            title: translate('Are you sure delete this articles'),
                            className: 'custom-modal',
                            okText: t('sure'),
                            cancelText: t('ignore'),
                            okButtonProps: {
                                type: 'primary',
                                danger: true,
                                className: 'rounded-lg no-shadow no-text-shadow no-border',
                            },
                            cancelButtonProps: {
                                className: 'rounded-lg no-shadow no-text-shadow no-border text-color-200',
                            },
                            onOk: () => {
                                dispatch(
                                    createAsyncAction({
                                        apiInfo: post_deletePost_Api,
                                        query: {
                                            ':post_id': item.id,
                                        },
                                    })
                                )
                            },
                        })
                        break
                }
                break
            case 'vote':
                handleVote()
                break
            case 'voteUp':
                handleExtraVote(VoteTypes.UP)
                break
            case 'voteDown':
                handleExtraVote(VoteTypes.DOWN)
                break
            case 'pin':
                dispatch(
                    createAsyncAction({
                        apiInfo: pin_mark_Api,
                        query: {
                            ':container': _.get(item, 'container._type'),
                            ':container_id': _.get(item, 'container.id'),
                            ':type': type,
                            ':id': id,
                        },
                    })
                )
                break
            case 'unpin':
                dispatch(
                    createAsyncAction({
                        apiInfo: pin_unMark_Api,
                        query: {
                            ':container': _.get(item, 'container._type'),
                            ':container_id': _.get(item, 'container.id'),
                            ':type': _.get(item, '_type'),
                            ':id': _.get(item, 'id'),
                        },
                        onSuccess: () => setHide(true),
                    })
                )
                break
            case 'copy_link':
                copyToClipboard(`${ROOT_URL}${url}`)
                message.success(translate('copied'))
                break
            case 'rebookmark':
            case 'bookmark':
                handleRequiredLogin(() =>
                    setmodal(
                        <Modal
                            className="custom-modal"
                            destroyOnHidden
                            title={<div
                                className="text-center font-bold text-color-000 uppercase tracking-wide">{t('favorites')}</div>}
                            footer={null}
                            open={true}
                            onOk={null}
                            onCancel={() => setmodal(null)}>
                            <UseState>
                                {([refreshKey, setRefreshKey]) => (
                                    <Async
                                        key={refreshKey}
                                        apiInfo={{
                                            root: API_ROOT_URL,
                                            path: '/folders/folder/gets',
                                            method: 'GET',
                                            transform: createTransform(collectionsSchema),
                                        }}>
                                        {({response, isLoading}) => {
                                            if (isLoading) return <LoadingBlock/>

                                            const folders = _.get(response, 'data.data', []);

                                            return (
                                                <div className="space-y-3">
                                                    <div className="flex items-center flex-wrap">
                                                        <div
                                                            className="mb-1 flex-1 text-sm text-color-300 tracking-wider">
                                                            {t('list of folders')}
                                                        </div>
                                                        <UseState initialValue={0}>
                                                            {([count, setCount]) => {
                                                                const isToggle = count % 2
                                                                const toggle = () => setCount(count + 1)
                                                                return (
                                                                    <>
                                                                        {!isToggle && (
                                                                            <Button
                                                                                color="primary" variant="filled"
                                                                                onClick={toggle}
                                                                                style={{padding: '0 10px', height: 26}}
                                                                                className="flex flex-center button-rounded-md font-semibold text-xs leading-snug tracking-wide">
                                                                                {t('add folder')}
                                                                            </Button>
                                                                        )}
                                                                        {!!isToggle && (
                                                                            <ApiInfoForm
                                                                                onSuccess={() => {
                                                                                    toggle()
                                                                                    setRefreshKey(Date.now())
                                                                                }}
                                                                                apiInfo={{
                                                                                    root: API_ROOT_URL,
                                                                                    path: '/folders/folder/add',
                                                                                    method: 'POST',
                                                                                }}
                                                                                initialValues={{
                                                                                    title: '',
                                                                                }}>
                                                                                {({values, handleChange, handleSubmit, isSubmitting,}) => (
                                                                                    <div
                                                                                        className="w-full flex flex-wrap items-center justify-end gap-2">
                                                                                        <Input
                                                                                            name="title"
                                                                                            defaultValue={values.title}
                                                                                            className="block w-full animated zoomIn faster"
                                                                                            autoFocus
                                                                                            onChange={handleChange}
                                                                                            onBlur={(e) => {
                                                                                                if (!e.target.value.length) {
                                                                                                    toggle()
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                        <span
                                                                                            className="text-xs italic text-color-300 hover:text-color-100"
                                                                                            onClick={toggle}>
                                                                                            {t('cancel')}
                                                                                        </span>
                                                                                        <Button
                                                                                            size="small"
                                                                                            className="button-rounded-xs no-border text-xs font-medium px-2"
                                                                                            loading={isSubmitting}
                                                                                            onClick={() => handleSubmit()}
                                                                                            color="primary"
                                                                                            variant="solid">
                                                                                            {t('create')}
                                                                                        </Button>
                                                                                    </div>
                                                                                )}
                                                                            </ApiInfoForm>
                                                                        )}
                                                                    </>
                                                                )
                                                            }}
                                                        </UseState>
                                                    </div>
                                                    <nav className="w-full rounded-lg background-100 flex-1">
                                                        <div
                                                            onClick={() => {
                                                                dispatch(
                                                                    createAsyncAction({
                                                                        apiInfo: bookmarks_mark_Api,
                                                                        query: {
                                                                            ':container': 'user',
                                                                            ':container_id': _.get(login, 'username'),
                                                                            ':type': type,
                                                                            ':id': id,
                                                                        },
                                                                    })
                                                                )
                                                                setmodal(null)
                                                            }}
                                                            className="px-3 py-2 cursor-pointer font-semibold text-color-300 hover:text-color-000">
                                                            {t('no categorized')}
                                                        </div>
                                                        {
                                                            folders.map((folder, index) => {

                                                                return (
                                                                    <SelectEntityItem
                                                                        key={index}
                                                                        item={folder}
                                                                        schema={baseItemSchema}>
                                                                        {(item) => {
                                                                            return (
                                                                                <div
                                                                                    onClick={() => {
                                                                                        dispatch(
                                                                                            createAsyncAction({
                                                                                                apiInfo: bookmarks_mark_Api,
                                                                                                query: {
                                                                                                    ':container': 'folder',
                                                                                                    ':container_id': item.id,
                                                                                                    ':type': type,
                                                                                                    ':id': id,
                                                                                                },
                                                                                            })
                                                                                        )
                                                                                        setmodal(null)
                                                                                    }}
                                                                                    style={{
                                                                                        minWidth: 100,
                                                                                    }}
                                                                                    className="px-3 py-2 cursor-pointer border-t italic text-sm text-color-300 hover:text-color-000 flex items-center gap-2">
                                                                                    <IoFolderOpenOutline/>
                                                                                    {item.title}
                                                                                </div>
                                                                            )
                                                                        }}
                                                                    </SelectEntityItem>
                                                                )
                                                            })
                                                        }

                                                    </nav>
                                                </div>
                                            )
                                        }}
                                    </Async>
                                )}
                            </UseState>
                        </Modal>
                    )
                )

                break
            case 'unbookmark':
                handleRequiredLogin(() =>
                    dispatch(
                        createAsyncAction({
                            apiInfo: bookmarks_unMark_Api,
                            query: {
                                ':container': 'user',
                                ':container_id': _.get(login, 'username'),
                                ':type': type,
                                ':id': id,
                            },
                        })
                    )
                )

                break
            case 'message':
                break
            case 'report':
                handleReport({
                    ref_type: getType(item),
                    ref_id: item?.id,
                    feedback_category_id: 'article-report-action'
                })
                break
            default:
                break
        }
    }

    const allowActions = item.edit
        ? {
            ...defaultActions,
            pin: container && container.edit,
            unpin: container && container.edit,
            edit: item.edit,
            delete: true,
            report: true,
        }
        : {
            ...defaultActions,
            pin: container && container.edit,
            unpin: container && container.edit,
            edit: item.edit,
            delete: false,
            report: true,
        }

    const actions = Object.keys(defaultActions)
        .filter((key) => defaultActions[key] && allowActions[key])
        .filter((key) => !(key === 'vote' && item._type === 'poll_question'))
        .reduce((result, key) => {
            result[key] = true
            return result
        }, {})

    return (
        <FeedContext.Provider
            value={{
                handleClick,
                item,
                detail,
                actions,
                creatorId,
                created,
                creatorType,
                creatorName,
                title,
                photos,
                poll: type === 'poll_question' && item,
                article: type === 'article' && item,
                content_data,
                embed_data,
                embed,
                description,
                cover,
                type,
                id,
                url,
                shareUrl,
                vote_status,
                bookmark_status,
                total_votes,
                total_downvotes,
                mentions: item?.mentions,
            }}>
            <PermissionProvider
                permissions={{
                    ...actions,
                    ...item.available_actions
                }}>
                {children}
                {!!modal && modal}
                {reportModal}
            </PermissionProvider>
        </FeedContext.Provider>
    )
}
